import React from 'react';
import { TextProps } from 'react-native';
import styled from 'styled-components/native';

import { Feather } from '@expo/vector-icons';

import Colors from '../constants/Colors';

const StyledAlert = styled.View<AlertBoxProps>`
  border-radius: 8px;
  flex-direction: row;
  padding: 24px;
  width: ${p => (p.fullWidth ? '100%' : 'auto')};
  background-color: ${p =>
    p.severity === 'success'
      ? Colors.successBackground
      : p.severity === 'warning'
      ? Colors.warningBackground
      : p.severity === 'error'
      ? Colors.errorBackground
      : p.severity === 'info'
      ? Colors.infoBackground
      : '#ffd0dd'};
` as React.FC<AlertBoxProps>;

const StyledIconView = styled.View`
  margin-right: 16px;
`;

const StyledText = styled.Text<AlertBoxProps>`
  font-family: 'WorkSans-SemiBold';
  font-size: 14px;
  line-height: 22px;
  flex: 1 1 auto;
  flex-wrap: wrap;
  color: ${p =>
    p.severity === 'success'
      ? Colors.success
      : p.severity === 'warning'
      ? Colors.warning
      : p.severity === 'error'
      ? Colors.error
      : p.severity === 'info'
      ? Colors.info
      : '#fff'};
` as React.FC<AlertBoxProps>;

export type AlertBoxProps = TextProps & {
  severity?: 'error' | 'warning' | 'info' | 'success';
  fullWidth?: boolean;
};

const AlertBox: React.FC<AlertBoxProps> = ({ children, ...props }) => {
  const severity = props.severity;
  return (
    <StyledAlert {...props}>
      <StyledIconView>
        <Feather
          name='info'
          color={
            severity === 'success'
              ? Colors.success
              : severity === 'warning'
              ? Colors.warning
              : severity === 'error'
              ? Colors.error
              : severity === 'info'
              ? Colors.info
              : '#000'
          }
          size={24}
        />
      </StyledIconView>
      <StyledText {...props}>{children}</StyledText>
    </StyledAlert>
  );
};

export default AlertBox;
